import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { HotelCreationRequest, HotelData, HotelEditRequest, HotelSearchFilter } from "../../models/hotel.model";

export const hotelCreationRequest = createAction(
        '[Hotel] Hotel creation request', props<{ hotelCreationRequest: HotelCreationRequest }>());

export const hotelCreationSuccess = createAction(
        '[Hotel] Hotel creation success', props<{ createdHotel: HotelData }>());

export const hotelCreationFail = createAction(
        '[Hotel] Hotel creation fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const hotelEdit = createAction(
        '[Hotel] Hotel edit', props<{ hotelToEdit: HotelData }>());

export const hotelCopy = createAction(
        '[Hotel] Hotel copy', props<{ hotelToCopy: HotelData }>());

export const hotelEditSave = createAction(
        '[Hotel] Hotel edit save', props<{ hotelToEdit: HotelEditRequest }>());

export const hotelEditSaveSuccess = createAction(
        '[Hotel] Hotel edit save success', props<{ editedHotel: HotelData }>());

export const hotelEditSaveFail = createAction(
        '[Hotel] Hotel edit fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const hotelView = createAction(
        '[Hotel] Hotel view', props<{ hotelToView: HotelData }>());

export const hotelSearchRequest = createAction(
        '[Hotel] Hotel search request', props<{ searchFilter: HotelSearchFilter }>());

export const hotelSearchAllRequest = createAction(
        '[Hotel] Hotel search all request');

export const hotelSearchSuccess = createAction(
        '[Hotel] Hotel search success', props<{ searchResult: HotelData[] }>());

export const hotelSearchDataReset = createAction(
        '[Hotel] Hotel search data reset');

export const hotelSearchFail = createAction(
        '[Hotel] Hotel search fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const hotelDeleteRequest = createAction(
        '[Hotel] Hotel delete request', props<{ hotelId: number }>());

export const hotelDeleteSuccess = createAction(
        '[Hotel] Hotel delete success', props<{ hotelId: number }>());

export const hotelDeleteFail = createAction(
        '[Hotel] Hotel delete fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());